import React from "react";
import { Filter, SearchInput } from "react-admin";
import DocFileTypeInput from "./input/DocFileTypeInput";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    width: "200px",
  },
}));

const Filters = (props) => {
  const classes = useStyles();
  return (
    <Filter {...props}>
      <SearchInput source="q" alwaysOn fullWidth />
      <DocFileTypeInput
        source="doc_file_type_id"
        emptyText="ra.action.all"
        alwaysOn
        className={classes.root}
      />
    </Filter>
  );
};
export default Filters;
